(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nagma-banners"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nagma-banners')) {
    if (/[?&]banners=1/.test(location.search)) document.documentElement.classList.add('nb-preview');
    customElements.define('nagma-banners', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.nb__slide')];
        this.dots = [...this.querySelectorAll('.nb__dot')];
        this.i = 0;
        if (this.hasAttribute('data-preview-only') && document.documentElement.classList.contains('nb-preview')) {
          document.querySelectorAll('nagma-home .nh-hero').forEach(el => el.style.display = 'none');
        }
        this.dots.forEach((d, k) => d.addEventListener('click', () => { this.go(k); this.start(); }));
        let x0 = null;
        this.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', e => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { this.go(this.i + (dx > 0 ? 1 : -1)); this.start(); } x0 = null; });
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.start();
      }
      go(n) {
        const len = this.slides.length; if (!len) return;
        this.i = (n + len) % len;
        this.slides.forEach((s, k) => { s.classList.toggle('is-active', k === this.i); s.setAttribute('aria-hidden', k === this.i ? 'false' : 'true'); });
        this.dots.forEach((d, k) => d.classList.toggle('is-active', k === this.i));
      }
      start() { this.stop(); if (this.slides.length > 1) this.t = setInterval(() => this.go(this.i + 1), (parseInt(this.dataset.interval) || 6) * 1000); }
      stop() { clearInterval(this.t); }
      disconnectedCallback() { this.stop(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nagma-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nagma-home')) {
  customElements.define('nagma-home', class extends HTMLElement {
    connectedCallback() {
      this.classList.add('js');
      this.rtl = getComputedStyle(this).direction === 'rtl';
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.querySelectorAll('[data-hero]').forEach((h) => this.initHero(h));
      this.querySelectorAll('[data-rail]').forEach((r) => this.initRail(r));
      this.initReveal();
      this.initParallax();
    }
    initHero(h) {
      const slides = [...h.querySelectorAll('[data-slide]')];
      const dots = [...h.querySelectorAll('[data-dot]')];
      if (slides.length < 2) return;
      const ms = parseInt(h.dataset.interval, 10) || 6000;
      h.style.setProperty('--nh-int', ms + 'ms');
      let i = 0, t = null, paused = false, left = ms, started = 0;
      const go = (n) => {
        slides[i].classList.remove('is-active'); dots[i] && dots[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
        const d = dots[i]; if (d) { d.classList.remove('is-active'); void d.offsetWidth; d.classList.add('is-active'); }
        schedule(ms);
      };
      const schedule = (dur) => { clearTimeout(t); left = dur; started = Date.now(); if (!paused && !this.reduce) t = setTimeout(() => go(i + 1), dur); };
      const pause = () => { if (paused) return; paused = true; clearTimeout(t); left -= Date.now() - started; h.classList.add('is-paused'); };
      const resume = () => { if (!paused) return; paused = false; h.classList.remove('is-paused'); schedule(Math.max(left, 400)); };
      dots.forEach((d, n) => d.addEventListener('click', () => go(n)));
      h.addEventListener('mouseenter', pause); h.addEventListener('mouseleave', resume);
      let x0 = null;
      h.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      h.addEventListener('touchend', (e) => {
        if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 45) go(i + ((dx < 0) === this.rtl ? -1 : 1));
      });
      new IntersectionObserver(([en]) => (en.isIntersecting ? resume() : pause())).observe(h);
      schedule(ms);
    }
    initRail(r) {
      const sec = r.closest('.nh-rail');
      const step = (dir) => {
        const card = r.querySelector('.nh-card'); if (!card) return;
        const w = card.getBoundingClientRect().width + 16;
        r.scrollBy({ left: dir * w * (this.rtl ? -1 : 1), behavior: 'smooth' });
      };
      sec.querySelector('[data-rail-next]')?.addEventListener('click', () => step(1));
      sec.querySelector('[data-rail-prev]')?.addEventListener('click', () => step(-1));
    }
    initReveal() {
      const els = this.querySelectorAll('.nh-rv');
      if (!('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
      const io = new IntersectionObserver((ens) => ens.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      els.forEach((e) => io.observe(e));
    }
    initParallax() {
      if (this.reduce) return;
      const els = [...this.querySelectorAll('[data-parallax]')];
      if (!els.length) return;
      let ticking = false;
      const run = () => {
        const vh = innerHeight;
        els.forEach((el) => {
          const r = el.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) return;
          const k = parseFloat(el.dataset.parallax);
          const off = (r.top + r.height / 2 - vh / 2) * k;
          const tgt = el.querySelector('img') && el.classList.contains('nh-ed__big') ? el.querySelector('img') : el;
          tgt.style.transform = `translate3d(0, ${(-off).toFixed(1)}px, 0)`;
        });
        ticking = false;
      };
      addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
      run();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
